<ion-toolbar slp-ionic-platform *ngIf="platform.isDesktop()">
  <nav>
    <ion-label [routerLink]="['/home']" class="page-menu">{{ "commons.menu.home" | translate }}</ion-label>
  </nav>
  <nav *ngIf="canViewAdmin">
    <ion-label id="admin-option" (click)="toggleAdminSubMenu(true, $event)">
      <ion-icon [name]="adminIcon"></ion-icon>{{ "commons.menu.administration" | translate }}
    </ion-label>
  </nav>
  <nav *ngIf="canViewAccounts">
    <ion-label id="accounts-option" (click)="toggleAccountsSubMenu(true, $event)">
      <ion-icon [name]="accountsIcon"></ion-icon>
      {{ "commons.menu.accounts" | translate }}
    </ion-label>
  </nav>
  <nav *ngIf="canViewReports || canDownloadReportFiles">
    <ion-label id="reports-option" (click)="toggleReportsSubMenu(true, $event)">
      <ion-icon [name]="reportsIcon"></ion-icon>{{ "commons.menu.reports" | translate }}
    </ion-label>
  </nav>
  <nav *ngIf="canViewPrograms">
    <ion-label>
      <ion-icon name="caret-forward-outline"></ion-icon>{{ "commons.menu.programs" | translate }}
    </ion-label>
  </nav>
</ion-toolbar>
<ion-popover reference="event" #adminPopover alignment="left" showBackdrop="false"
  (ionPopoverWillDismiss)="toggleAdminSubMenu(false)">
  <ng-template>
    <ion-item [routerLink]="['/administration/users']" (click)="toggleAdminSubMenu(false)" *ngIf="canViewUsers">
      <ion-label>{{ "commons.menu.viewUsers" | translate }}</ion-label>
    </ion-item>
    <ion-item [routerLink]="" *ngIf="canInviteUsers" (click)="showInviteUser()">
      <ion-label>{{ "commons.menu.inviteUsers" | translate }}</ion-label>
    </ion-item>
    <ion-item [routerLink]="['/administration/orgs']" (click)="toggleAdminSubMenu(false)" *ngIf="canViewOrgs">
      <ion-label>{{ "commons.menu.viewOrgs" | translate }}</ion-label>
    </ion-item>
    <ion-item [routerLink]="['/administration/program-card-art']" (click)="toggleAdminSubMenu(false)" *ngIf="canUpdateProgramCardArt">
      <ion-label>{{ "commons.menu.programCardArt" | translate }}</ion-label>
    </ion-item>
    <ion-item [routerLink]="['/administration/negative-balance-summary']" (click)="toggleAdminSubMenu(false)" *ngIf="canViewNegativeBalanceSummary">
      <ion-label>{{ "commons.menu.negativeBalanceSummary" | translate }}</ion-label>
    </ion-item>
  </ng-template>
</ion-popover>
<ion-popover id="accountsOptionsPopover" reference="event" #accountsPopover alignment="left" showBackdrop="false"
  (ionPopoverWillDismiss)="toggleAccountsSubMenu(false)">
  <ng-template>
    <ion-item [routerLink]="['/accounts/search']" (click)="toggleAccountsSubMenu(false)" *ngIf="canSearchAccount">
      <ion-label>{{ "commons.menu.accountSearch" | translate }}</ion-label>
    </ion-item>
  </ng-template>
</ion-popover>
<ion-popover id="reportsPopover" reference="event" #reportsPopover alignment="left" showBackdrop="false"
  (ionPopoverWillDismiss)="toggleReportsSubMenu(false)">
  <ng-template>
    <ion-item *ngIf="canDownloadReportFiles" [routerLink]="['/reports/download']" (click)="toggleReportsSubMenu(false)">
      <ion-label>{{ "commons.menu.reportDownload" | translate }}</ion-label>
    </ion-item>
    <ion-item *ngFor="let report of userReports" (click)="toggleReportsSubMenu(false)"
      [routerLink]="['/reports/report', report.rId]">
      <ion-label>{{ report.reportName }}</ion-label>
    </ion-item>
  </ng-template>
</ion-popover>

<ion-menu *ngIf="!platform.isDesktop()" contentId="main-content">
  <ion-header>
    <ion-toolbar>
      <ion-title>{{ "commons.menu.menu" | translate }}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item>
        <ion-label [routerLink]="['/home']">{{ "commons.menu.home" | translate }}</ion-label>
      </ion-item>

      <ion-item id="AdminSubMenuItem" *ngIf="canViewAdmin" (click)="toggleAdminSubMenu()">
        <ion-label>
          <ion-icon [name]="adminMobileIcon"></ion-icon>{{ "commons.menu.administration" | translate }}
        </ion-label>
      </ion-item>
      <ion-menu-toggle [hidden]="!isAdminOpen">
        <ion-list>
          <ion-item *ngIf="canViewUsers" [routerLink]="['/administration/users']">
            <ion-label>{{ "commons.menu.viewUsers" | translate }}</ion-label>
          </ion-item>
          <ion-item *ngIf="canInviteUsers" (click)="showInviteUser()">
            <ion-label>{{ "commons.menu.inviteUsers" | translate }}</ion-label>
          </ion-item>
          <ion-item *ngIf="canViewNegativeBalanceSummary" [routerLink]="['/administration/negative-balance-summary']">
            <ion-label>{{ "commons.menu.negativeBalanceSummary" | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-menu-toggle>
      <ion-item id="accountSubMenuItem" (click)="toggleAccountsSubMenu()" *ngIf="canViewAccounts">
        <ion-label>
          <ion-icon [name]="accountsMobileIcon"></ion-icon>{{ "commons.menu.accounts" | translate }}
        </ion-label>
      </ion-item>
      <ion-menu-toggle [hidden]="!isAccountsOpen">
        <ion-list>
          <ion-item *ngIf="canSearchAccount">
            <ion-label>{{ "commons.menu.accountSearch" | translate }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-menu-toggle>

      <ion-item *ngIf="canViewReports || canDownloadReportFiles" (click)="toggleAdminSubMenu()">
        <ion-label>
          <ion-icon [name]="reportsMobileIcon"></ion-icon>{{ "commons.menu.reports" | translate }}
        </ion-label>
      </ion-item>
      <ion-menu-toggle [hidden]="!isReportsOpen">
        <ion-list>
          <ion-item *ngIf="canDownloadReportFiles" [routerLink]="['/reports/download']"
            (click)="toggleReportsSubMenu(false)">
            <ion-label>{{ "commons.menu.reportDownload" | translate }}</ion-label>
          </ion-item>
          <ion-item *ngFor="let report of userReports" [routerLink]="['/reports/report', report.rId]"
            (click)="toggleReportsSubMenu(false)">
            <ion-label>{{ report.reportName }}</ion-label>
          </ion-item>
        </ion-list>
      </ion-menu-toggle>
      <ion-item *ngIf="canViewPrograms">
        <ion-label>
          <ion-icon name="chevron-forward-outline"></ion-icon>{{ "commons.menu.programs" | translate }}
        </ion-label>
      </ion-item>

      <ion-item>
        <ion-label>{{ "commons.menu.myAccount" | translate }}</ion-label>
      </ion-item>
      <ion-item lines="none"></ion-item>
      <ion-item>
        <ion-label>{{ "commons.menu.submitTicket" | translate }}</ion-label>
      </ion-item>
      <ion-item>
        <ion-label>{{ "commons.menu.contactUs" | translate }}</ion-label>
      </ion-item>
      <ion-item lines="none"></ion-item>
      <ion-item id="logoutItem" (click)="logout()">
        <ion-label>
          <ion-icon name="log-out-outline"></ion-icon> {{ "commons.menu.logOut" | translate }}
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>